import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { EMOTION_KEYWORD } from '@/constants';
import Happy from '@/images/emotions/Happy.svg';
import Natural from '@/images/emotions/Natural.svg';
import Serious from '@/images/emotions/Serious.svg';
import Surprise from '@/images/emotions/Surprise.svg';
import { PolotnoStoreActivePageKeys, usePolotnoActivePageState } from '@/pages/AdvancedEditor/hooks';
import { MenuItem } from '@/pages/AdvancedEditor/types';
import { useAnalytics } from '@/services/analytics';
import theme from '@/theme';
import { Emotion } from '@/utils/types';
import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { ControlButton } from '../../../common/ControlButton';

const Container = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
`;

const controls: MenuItem[] = [
    {
        key: Emotion.Natural,
        srcValue: Natural,
        name: 'Natural',
        type: EMOTION_KEYWORD,
    },
    {
        key: Emotion.Happy,
        srcValue: Happy,
        name: 'Happy',
        type: EMOTION_KEYWORD,
    },
    {
        key: Emotion.Surprise,
        srcValue: Surprise,
        name: 'Surprised',
        type: EMOTION_KEYWORD,
    },
    {
        key: Emotion.Serious,
        srcValue: Serious,
        name: 'Serious',
        type: EMOTION_KEYWORD,
    },
];

export const EmotionsControl = observer(() => {
    const [selectedEmotion, setSelectedEmotion] = usePolotnoActivePageState(PolotnoStoreActivePageKeys.selectedEmotion);
    const mixpanel = useAnalytics();

    const handleChange = (emotion: Emotion) => {
        mixpanel?.track('driver-choice', { event: 'click' });
        setSelectedEmotion(emotion);
    };

    return (
        <Container>
            {controls.map((control, index) => (
                <Tooltip
                    title={control.name}
                    placement="top"
                    slotProps={{ tooltip: { sx: { backgroundColor: theme.colors.secondary[900], padding: '8px', fontSize: '14px' } } }}
                    PopperProps={{
                        modifiers: [{ name: 'offset', options: { offset: [0, -6] } }],
                    }}>
                    <ControlButton
                        name={control.name}
                        onClick={() => handleChange(control.key as Emotion)}
                        selected={selectedEmotion ? control.key === selectedEmotion : index === 0}>
                        <MaskedIcon src={control.srcValue} size="20px" />
                    </ControlButton>
                </Tooltip>
            ))}
        </Container>
    );
});
